/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.clasestecnicas': 'Clases Técnicas',
  'clasesTecnicas.agregarClasesTecnicas': 'Crear Clases Técnicas',
  'clasesTecnicas.modificarClasesTecnicas': 'Editar Clases Técnicas',
  'clasesTecnicas.claseTecnicaId': 'Clase Técnica Id',
  'clasesTecnicas.empresaId': 'Empresa Id',
  'clasesTecnicas.claseTecnicaDescripcion': 'Descripción',
  'clasesTecnicas.VerClasesTecnicas': 'Ver Clases Técnicas',
};
